<template>
    <div class="vue-slider-navigation">
        <button class="slider-previous" @click="$emit('slider-previous')">
            <i class="icon-chevron-right"></i>
        </button>

        <button class="slider-next" @click="$emit('slider-next')">
            <i class="icon-chevron-right"></i>
        </button>
    </div>
</template>

<script>
export default {
    name: "SliderNavigation"
}
</script>